import { sortBy } from 'lodash';

import { PrivateGateway } from '@/core/gateways';
import { Database } from '@/core/types';

export async function getAvailableDatabases(extraHeaders: HeadersInit = {}) {
  const response = await PrivateGateway.getAvailableDatabases(extraHeaders);

  if (response.ok) {
    const data = await response.json();
    return sortBy<Database>(
      data.databases.filter((db: Database) => db.description),
      ['description']
    );
  } else {
    throw new Error('Could not get database users.');
  }
}
